// Magnifying glass zoom: a square lens follows the cursor over the product
// image and shows a magnified view of the area underneath it.
function clamp(value, min, max) {
  return Math.max(min, Math.min(value, max));
}

function createLensSquare(container, image) {
  const lens = document.createElement('div');
  lens.className = 'magnify-lens-square';
  lens.setAttribute('aria-hidden', 'true');
  lens.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
  container.appendChild(lens);
  return lens;
}

function updateLensSquare(lens, container, image, event, lensSize, zoomRatio) {
  const imageBounds = image.getBoundingClientRect();
  const containerBounds = container.getBoundingClientRect();
  const offsetX = imageBounds.left - containerBounds.left;
  const offsetY = imageBounds.top - containerBounds.top;

  let x = event.clientX - imageBounds.left;
  let y = event.clientY - imageBounds.top;
  x = clamp(x, 0, imageBounds.width);
  y = clamp(y, 0, imageBounds.height);

  const bgWidth = imageBounds.width * zoomRatio;
  const bgHeight = imageBounds.height * zoomRatio;
  let bgX = x * zoomRatio - lensSize / 2;
  let bgY = y * zoomRatio - lensSize / 2;
  bgX = clamp(bgX, 0, Math.max(bgWidth - lensSize, 0));
  bgY = clamp(bgY, 0, Math.max(bgHeight - lensSize, 0));

  let lensLeft = offsetX + x - lensSize / 2;
  let lensTop = offsetY + y - lensSize / 2;
  lensLeft = clamp(lensLeft, offsetX, offsetX + Math.max(imageBounds.width - lensSize, 0));
  lensTop = clamp(lensTop, offsetY, offsetY + Math.max(imageBounds.height - lensSize, 0));

  lens.style.width = `${lensSize}px`;
  lens.style.height = `${lensSize}px`;
  lens.style.left = `${lensLeft}px`;
  lens.style.top = `${lensTop}px`;
  lens.style.backgroundSize = `${bgWidth}px ${bgHeight}px`;
  lens.style.backgroundPosition = `-${bgX}px -${bgY}px`;
}

function enableMagnifyLens(lensSize, zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-lens');

  images.forEach((image) => {
    const container = image.closest('.product-media-container');
    if (!container) return;

    let lens;

    image.addEventListener('mouseenter', (event) => {
      if (!lens) lens = createLensSquare(container, image);
      lens.style.display = 'block';
      updateLensSquare(lens, container, image, event, lensSize, zoomRatio);
    });

    image.addEventListener('mousemove', (event) => {
      if (!lens) return;
      updateLensSquare(lens, container, image, event, lensSize, zoomRatio);
    });

    image.addEventListener('mouseleave', () => {
      if (lens) lens.style.display = 'none';
    });
  });
}

function enableMagnifyLensTouch(lensSize, zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-lens');

  images.forEach((image) => {
    const container = image.closest('.product-media-container');
    const opener = image.closest('.product__modal-opener');
    if (!container || !opener) return;

    let lens;

    opener.addEventListener('click', (event) => {
      event.stopImmediatePropagation();
      if (!lens) lens = createLensSquare(container, image);
      lens.style.display = 'block';
      updateLensSquare(lens, container, image, event, lensSize, zoomRatio);
    }, true);
  });

  document.addEventListener('click', () => {
    document.querySelectorAll('.magnify-lens-square').forEach((lens) => {
      lens.style.display = 'none';
    });
  });
}

if (window.matchMedia('(hover: hover)').matches) {
  enableMagnifyLens(180, 1.25);
} else {
  enableMagnifyLensTouch(180, 1.25);
}